/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	// Skin for what used to be called a Web-Accordion
	Module.SearchResultDisplay.Web = function(parent) {

		this.createSearchProcessor = function(defaults) {
			return SCS.search.orchestration.forWebSearch(
				this.$ctx.attr('data-sitesearch-gsahostname'),
				$('html').attr('lang') || 'de',
				defaults
			);
		};

		this.getIcon = function(result) {
			// jshint camelcase: false
			if(result.pagemap && result.pagemap.cse_thumbnail && result.pagemap.cse_thumbnail[0]) {
				return {src: result.pagemap.cse_thumbnail[0].src};
			}
		};

	};

})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultDisplay.Web.js
// module id = 73
// module chunks = 0